import { create } from "zustand";
import { supabase } from "@/integrations/supabase/client";

interface AdminState {
  isAdmin: boolean;
  isLoading: boolean;
  checkAdminStatus: () => Promise<void>;
}

export const useSuperAdmin = create<AdminState>((set) => ({
  isAdmin: false,
  isLoading: true,

  checkAdminStatus: async () => {
    set({ isLoading: true });
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        set({ isAdmin: false, isLoading: false });
        return;
      }

      const { data, error } = await supabase.rpc("is_admin_or_diretor", { _user_id: user.id });

      console.log("Admin Check Result (RPC):", { user_id: user.id, isAdmin: data, error });

      // FORCE ADMIN FOR DEBUGGING - REMOVE THIS LATER
      // set({ isAdmin: true }); 
      
      if (error) {
        console.error("Error checking admin status:", error);
        // Fallback: Check user metadata directly as a backup
        const isMetaAdmin = user.user_metadata?.role === 'admin' || user.user_metadata?.role === 'diretor';
        if (isMetaAdmin) {
             console.log("Fallback to metadata role: Admin granted");
             set({ isAdmin: true });
        } else {
             set({ isAdmin: false });
        }
      } else {
        set({ isAdmin: !!data });
      }
    } catch (error) {
      console.error("Unexpected error in admin check:", error);
      set({ isAdmin: false });
    } finally {
      set({ isLoading: false });
    }
  },
}));
